import React, { ReactElement } from 'react';
import { pageview } from '../lib/analytics';
import { mobilePageView } from '../lib/mobile';

interface Props {
  children?: ReactElement;
  url: string;
  mobileOnly?: boolean;
}

class AnalyticsPageView extends React.PureComponent<Props> {
  componentDidMount() {
    const { url, mobileOnly } = this.props;
    if (mobileOnly) {
      mobilePageView(url);
    } else {
      pageview(url);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default AnalyticsPageView;
